const panelTabs = {
    CHART: 'chart',
    HIGHLIGHTS: 'highlights',
    TABLE: 'table',
};

export default panelTabs;
